"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lightning = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Lightning = function Lightning() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.4545 0H18L13.6364 8.72727H18L9.81818 24L11.4545 13.0909H6L11.4545 0Z",
    clipRule: "evenodd"
  });
};

exports.Lightning = Lightning;